/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminUavPlatform
 */
export interface OutputAdminUavPlatform {
    /**
     * Aliases — допоміжні/альтернативні назви платформи (завжди масив, порожній -> []).
     * @type {Array<string>}
     * @memberof OutputAdminUavPlatform
     */
    aliases?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUavPlatform
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUavPlatform
     */
    freqControlMaxMhz?: number;
    /**
     * Частоти — діапазон: *Mhz нижня межа, *MaxMhz верхня (null = одна частота).
     * @type {number}
     * @memberof OutputAdminUavPlatform
     */
    freqControlMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUavPlatform
     */
    freqVideoMaxMhz?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUavPlatform
     */
    freqVideoMhz?: number;
    /**
     * Icon — силует борта на мапі: plane | quadcopter.
     * @type {string}
     * @memberof OutputAdminUavPlatform
     */
    icon?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUavPlatform
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUavPlatform
     */
    maxDurationMin?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUavPlatform
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUavPlatform
     */
    speedKmh?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUavPlatform
     */
    type?: string;
}

/**
 * Check if a given object implements the OutputAdminUavPlatform interface.
 */
export function instanceOfOutputAdminUavPlatform(value: object): boolean {
    return true;
}

export function OutputAdminUavPlatformFromJSON(json: any): OutputAdminUavPlatform {
    return OutputAdminUavPlatformFromJSONTyped(json, false);
}

export function OutputAdminUavPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminUavPlatform {
    if (json == null) {
        return json;
    }
    return {
        
        'aliases': json['aliases'] == null ? undefined : json['aliases'],
        'description': json['description'] == null ? undefined : json['description'],
        'freqControlMaxMhz': json['freqControlMaxMhz'] == null ? undefined : json['freqControlMaxMhz'],
        'freqControlMhz': json['freqControlMhz'] == null ? undefined : json['freqControlMhz'],
        'freqVideoMaxMhz': json['freqVideoMaxMhz'] == null ? undefined : json['freqVideoMaxMhz'],
        'freqVideoMhz': json['freqVideoMhz'] == null ? undefined : json['freqVideoMhz'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'id': json['id'] == null ? undefined : json['id'],
        'maxDurationMin': json['maxDurationMin'] == null ? undefined : json['maxDurationMin'],
        'name': json['name'] == null ? undefined : json['name'],
        'speedKmh': json['speedKmh'] == null ? undefined : json['speedKmh'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function OutputAdminUavPlatformToJSON(value?: OutputAdminUavPlatform | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aliases': value['aliases'],
        'description': value['description'],
        'freqControlMaxMhz': value['freqControlMaxMhz'],
        'freqControlMhz': value['freqControlMhz'],
        'freqVideoMaxMhz': value['freqVideoMaxMhz'],
        'freqVideoMhz': value['freqVideoMhz'],
        'icon': value['icon'],
        'id': value['id'],
        'maxDurationMin': value['maxDurationMin'],
        'name': value['name'],
        'speedKmh': value['speedKmh'],
        'type': value['type'],
    };
}

